"use client";

import createIcon from './util/createIcon';
export default createIcon('M1 3H23L12 22', 'TriangleDown');